import { render } from "./early-warning-and-monitoring.vue?vue&type=template&id=4c805d7a&scoped=true&ts=true"
import script from "./early-warning-and-monitoring.vue?vue&type=script&lang=ts"
export * from "./early-warning-and-monitoring.vue?vue&type=script&lang=ts"

import "./early-warning-and-monitoring.vue?vue&type=style&index=0&id=4c805d7a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c805d7a"]])

export default __exports__